import {
  GET_CMS,
  GET_CMS_FAILURE,
  GET_CMS_SUCCESS,
  UPDATE_CMS,
  UPDATE_CMS_FAILURE,
  UPDATE_CMS_SUCCESS,
  SHOW_CMS,
  SHOW_CMS_SUCCESS,
  SHOW_CMS_FAILURE,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getError: false,
  getData: null,
  updateLoader: false,
  updateData: null,
  updateError: false,
  showLoader: false,
  showData: null,
  showError: null,
};
function cmsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CMS:
      return { ...state, getLoader: true };
    case GET_CMS_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case GET_CMS_FAILURE:
      return { ...state, getError: true, getLoader: false };

    case UPDATE_CMS:
      return { ...state, updateLoader: true, updateData: action.payload };
    case UPDATE_CMS_SUCCESS:
      return { ...state, updateData: action?.payload, updateLoader: false };
    case UPDATE_CMS_FAILURE:
      return { ...state, updateError: true, updateLoader: false };

    case SHOW_CMS:
      return { ...state, showLoader: true };
    case SHOW_CMS_SUCCESS:
      return { ...state, showData: action?.payload, showLoader: false };
    case SHOW_CMS_FAILURE:
      return { ...state, showError: true, showLoader: false };

    default:
      return state;
  }
}

export default cmsReducer;
